import React from 'react';
import styles from './PageNotFound.module.scss'
import { BiBug } from "react-icons/bi";

const PageNotFound = () => {
    return (
        <div className={ styles.pageContainer }>
            <div className={ styles.container }>
                <div className={ styles.title }>
                    404
                </div>
                <div className={ styles.subtitle }>

                    Page not found
                </div>
                <div className={ styles.explain }>
                    We're sorry, the page you requested could not be found. please go back to safety or contact us.
                </div>
                <BiBug className={ styles.bug } />
            </div>
        </div>
    )

}

export default PageNotFound;
